import React from 'react'
import { WContainer } from 'components/atoms'
import { CantineListing, CantineMappa, Page } from 'components/organisms'

interface Props {
  pagina?: any
  cantine?: any[]
}

const CantineTemplate = (props: Props) => {
  const { cantine, pagina } = props

  return (
    <Page pagina={pagina} topBg="left" childrenContainerVariant="none" className="cantine-template">
      <CantineMappa cantine={cantine} />
      <WContainer>
        <CantineListing cantine={cantine} />
      </WContainer>
    </Page>
  )
}

export default CantineTemplate
